import React from 'react';
import { useTranslation } from 'react-i18next';
import { cn } from '../../lib/utils';
import { useHapticFeedback } from '../../hooks/useHapticFeedback';
import { GRADIENT_CLASS } from '../../lib/gradients';
import type { Period } from '../../constants/pricing';

interface PeriodSelectorProps {
  period: Period;
  onPeriodChange: (period: Period) => void;
  showBestValue?: boolean;
  size?: 'default' | 'compact';
}

export const PeriodSelector: React.FC<PeriodSelectorProps> = ({
  period,
  onPeriodChange,
  showBestValue = true,
  size = 'default'
}) => {
  const { t } = useTranslation();
  const { impactOccurred } = useHapticFeedback();

  const handleToggle = (newPeriod: Period) => {
    impactOccurred('medium');
    onPeriodChange(newPeriod);
  };

  const buttonClass = size === 'compact' 
    ? 'max-[360px]:py-2 max-[360px]:text-xs'
    : '';

  return (
    <div className="flex bg-tg-secondary-bg rounded-xl p-1 relative gap-1 border border-pink-500/10">
      <button 
        className={cn(
          'flex-1 py-2.5 border-none bg-transparent rounded-lg text-sm text-tg-hint cursor-pointer transition-all duration-300 relative flex items-center justify-center font-medium',
          period === '3' && `${GRADIENT_CLASS} text-white font-semibold scale-[1.02] shadow-[0_2px_12px_rgba(255,0,128,0.2)]`,
          buttonClass
        )}
        onClick={() => handleToggle('3')}
      >
        3 {t('PROFILE_SCREEN.PREMIUM.MONTHS')}
      </button>
      <button 
        className={cn(
          'flex-1 py-2.5 border-none bg-transparent rounded-lg text-sm text-tg-hint cursor-pointer transition-all duration-300 relative flex items-center justify-center font-medium',
          period === '6' && `${GRADIENT_CLASS} text-white font-semibold scale-[1.02] shadow-[0_2px_12px_rgba(255,0,128,0.2)]`,
          buttonClass
        )}
        onClick={() => handleToggle('6')}
      >
        6 {t('PROFILE_SCREEN.PREMIUM.MONTHS')}
      </button>
      <button 
        className={cn(
          'flex-1 py-2.5 border-none bg-transparent rounded-lg text-sm text-tg-hint cursor-pointer transition-all duration-300 relative flex items-center justify-center font-medium',
          period === '12' && `${GRADIENT_CLASS} text-white font-semibold scale-[1.02] shadow-[0_2px_12px_rgba(255,0,128,0.2)]`,
          buttonClass
        )}
        onClick={() => handleToggle('12')}
      >
        12 {t('PROFILE_SCREEN.PREMIUM.MONTHS')}
        {showBestValue && (
          <span className="absolute -top-2 -right-2 bg-gradient-pink text-white text-[10px] px-2 py-0.5 rounded-md font-semibold whitespace-nowrap shadow-[0_2px_8px_rgba(255,0,128,0.2)]">
            {t('PROFILE_SCREEN.PREMIUM.BEST_VALUE')}
          </span>
        )}
      </button>
    </div>
  );
};

